"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function attr(attr) {
    return function (d) { return d[attr]; };
}
exports.attr = attr;
//# sourceMappingURL=shortcuts.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/utils/shortcuts.js
// module id = 159
// module chunks = 0 1